<template>
  <v-app>
    <div v-if="loading_page === true">
      <v-sheet
        :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`"
        class="pa-3"
      >
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-if="loading_page === false">
      <div
        class="color_header_cart_take_out_table"
        :style="{ background: bg_color }"
      >
        <div class="d-flex justify-space-between align-center pa-3">
          <div class="d-flex align-center">
            <div class="img_cart_header_cart_take_out_table">
              <img src="@/assets/shopping-cart.png" />
            </div>
            <div class="ml-2 color_title_cart_take_out_table">
              {{ $t("cart") }}
            </div>
          </div>
          <div
            class="link_back_cart_take_out_table"
            @click="$router.push('/takeoutusertable/' + $route.params.token)"
          >
            <div>
              <v-icon color="white" size="30">mdi-close</v-icon>
            </div>
          </div>
        </div>
      </div>
      <div class="detail_cart_take_out_table">
        <div class="d-flex justify-space-between mb-2">
          <div>{{ $t("order") }} # {{ table_order }}</div>
          <div>{{ $t("table") }} {{ table_name }}</div>
        </div>
        <div
          class="mb-2 cart_detail_cart_take_out_table"
          v-for="(cart, key) in $store.state.cartListTakeOutTable"
          :key="key"
        >
          <v-card
            class="pa-3 mr-1"
            color="#eeeeee"
            @click="editCartListUser(cart.id, cart.foodmenu_id)"
          >
            <div class="d-flex justify-space-between align-center">
              <div class="d-flex align-center">
                <div class="mr-2 pa-3">
                  {{ Intl.NumberFormat().format(cart.amount) }}
                </div>
                <div>
                  {{ selectedLanguage == 'en' && cart.nameEng ? cart.nameEng : cart.name }}
                  <div class="topping_food_cart_take_out_table">
                    <ul>
                      <li
                        v-for="(
                          topping_name_list, key_topping
                        ) in cart.topping_name"
                        :key="key_topping"
                      >
                        <span
                          v-if="cart.amount_topping[key_topping]"
                          class="amount_list_topping_cart_take_out_table"
                          >{{ cart.amount_topping[key_topping] }}</span
                        >
                        {{
                          selectedLanguage == "en" &&
                          cart.topping_name_en[key_topping] != "null"
                            ? cart.topping_name_en[key_topping]
                            : topping_name_list
                        }}
                        ({{ $t("price") }}
                        {{ cart.toppingprice_list[key_topping] }} ฿)
                      </li>
                    </ul>
                  </div>
                  <div class="note_cart_take_out_table" v-if="cart.description">
                    {{ $t("note") }} : {{ cart.description }}
                  </div>
                </div>
              </div>
              <div>
                {{
                  Intl.NumberFormat().format(
                    cart.total_price + cart.toppingprice * cart.amount
                  )
                }}
                ฿
              </div>
            </div>
          </v-card>
          <v-card class="delete_cart_detail_cart_take_out_table ml-1">
            <div>
              <v-icon
                color="error"
                size="40"
                @click="deleteCartListUser(cart.id)"
                >mdi-close</v-icon
              >
            </div>
          </v-card>
        </div>
      </div>

      <div class="pa-3 confirm_cart_take_out_table">
        <div class="d-flex justify-center">
          <div class="result_cart_all_cart_take_out_table mr-2">
            <img src="@/assets/hand.png" />
          </div>
          <h2>
            ราคารวม
            {{
              Intl.NumberFormat().format(
                $store.state.cartListTakeOutTable.reduce((sum, number) => {
                  return (
                    sum +
                    number.total_price +
                    number.toppingprice * number.amount
                  );
                }, 0)
              )
            }}
            บาท
          </h2>
        </div>
        <v-btn
          width="100%"
          height="55"
          class="titlefont_cart_take_out_table white--text"
          :style="{ background: bg_color }"
          @click="sendFood()"
          >{{ $t("confirm") }}</v-btn
        >
      </div>

      <v-dialog v-model="alert_show_add" persistent max-width="600">
        <v-card>
          <v-card-title> {{ $t("success") }} </v-card-title>

          <v-card-text>
            {{ $t("waitAMoment") }}
            <!-- สั่งอาหารเรียบร้อย กรุณารออาหาร 10-20 นาทีนะคะกรุณารออาหารสักครู่ -->
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="black" text @click="confirmSuccess()">
              {{ $t("close") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="alert_show_error" persistent max-width="600">
        <v-card>
          <v-card-title class="error--text">
            {{ $t("error") || "เกิดข้อผิดพลาด" }}
          </v-card-title>

          <v-card-text>
            {{ error_message }}
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="alert_show_error = false">
              {{ $t("close") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
    <EditToppingMenu />
  </v-app>
</template>

<script>
import { HTTP } from "@/axios.js";
import Vue from "vue";
import VueI18n from "vue-i18n";
import store from "@/store"; // นำเข้า Vuex store
import EditToppingMenu from "@/components/menuuser/addmenu/EditToppingMenu.vue";
Vue.use(VueI18n);
const messages = {
  en: {
    cart: "My Cart",
    order: "Order",
    table: "Table",
    noteAlert:
      "**Not finished eating, adjust the money! According to the price of the food in the ala carte style**",
    total: "Total price",
    confirm: "Confirm Order",
    success: "Success",
    wait: "Order successful, please wait for food 10-20 minutes",
    close: "Close",
    bath: "Bath",
    note: "Note",
    price: "Price",
    waitAMoment: "Ordered food already. Please wait a moment for the food.",
    error: "Error",
  },
  th: {
    cart: "ตะกร้าอาหารของฉัน",
    order: "ออเดอร์ #",
    table: "โต๊ะ",
    noteAlert: "**ทานไม่หมด ปรับเงิน! ตามราคาอาหารแบบอลาคาส**",
    total: "ราคารวม",
    confirm: "ยืนยันการสั่งอาหาร",
    success: "สำเร็จ",
    wait: "สั่งอาหารเรียบร้อย กรุณารออาหารสักครู่",
    close: "ตกลง",
    bath: "บาท",
    note: "หมายเหตุ",
    price: "ราคา",
    waitAMoment: "สั่งอาหารเรียบร้อย กรุณารออาหารสักครู่",
    error: "เกิดข้อผิดพลาด",
  },
};
const i18n = new VueI18n({
  locale: store.state.lang, // กำหนดภาษาหลัก
  messages,
});
export default {
  i18n,
  name: "cartTakeOutTable",
  components: {
    EditToppingMenu,
  },
  inject: {
    theme: {
      default: {
        isDark: false,
      },
    },
  },
  data() {
    return {
      loading_page: true,
      bg_color: "linear-gradient(to top, #038cc1 , #55c0e9)",
      table_name: "",
      table_order: "",
      alert_show_add: false,
      alert_show_error: false,
      error_message: "",
      is_submitting: false,
      selectedLanguage: store.state.lang,
    };
  },
  methods: {
    async colorRestaurant() {
      HTTP.get("/showColor")
        .then((response) => {
          if (response.data.successful === true) {
            this.bg_color = response.data.color_code;
            this.loading_page = false;
          }
        })
        .catch((error) => {
          if (error.response.status === 401) {
            this.$store.commit("logOutSuccess");
            this.$router.push("/login");
          }
          if (error.response.status === 500) {
            this.$router.push("/nametakeoutuser");
          }
        });
    },
    async editCartListUser(id, foodmenu_id) {
      const dataList = {
        id: id,
        foodmenu_id: foodmenu_id,
        type_cart: "cart_take_out_table",
      };
      this.$root.$emit("getDetail", dataList);
    },
    async deleteCartListUser(id) {
      const deleteId = {
        id: id,
      };
      this.$store.commit("deleteCartTakeOutTableListUser", deleteId);
    },
    async tableDetail() {
      await HTTP.get(
        "/customer/open-buffet/" + this.$store.state.cartTakeOutTableId,
        {
          headers: {
            Authorization: `Bearer ${this.$store.state.token}`,
          },
        }
      )
        .then((response) => {
          if (response.data.successful === true) {
            this.table_name = response.data.opentable_detail.name;
          }
        })
        .catch((error) => {
          if (error.response.status === 401) {
            this.$store.commit("logOutSuccess");
            this.$router.push("/login");
          }
          if (error.response.status === 500) {
            this.$router.push("/thankyouuser");
          }
        });
      await HTTP.get(
        "/customer/order-number/" + this.$store.state.cartTakeOutTableId,
        {
          headers: {
            Authorization: `Bearer ${this.$store.state.token}`,
          },
        }
      )
        .then((response) => {
          if (response.data.successful === true) {
            this.table_order = response.data.order_number;
            this.loading_page = false;
          }
        })
        .catch((error) => {
          if (error.response.status === 401) {
            this.$store.commit("logOutSuccess");
            this.$router.push("/login");
          }
          if (error.response.status === 500) {
            this.$router.push("/thankyouuser");
          }
        });
    },
    async sendFood() {
      // ป้องกันการ submit ซ้ำ
      if (this.is_submitting) {
        return;
      }

      if (this.$store.state.cartListTakeOutTable.length > 0) {
        this.is_submitting = true;
        this.loading_page = true;
        let foodmenu_id = [];
        let amount = [];
        let price = [];
        let total_price = [];
        let toping_id = [];
        let topping_price = [];
        let description = [];
        let type_status = [];
        this.$store.state.cartListTakeOutTable.forEach((detail) => {
          foodmenu_id.push(detail.foodmenu_id);
          amount.push(detail.amount);
          price.push(detail.price);
          total_price.push(detail.total_price);
          topping_price.push(detail.toppingprice);
          toping_id.push(detail.topping_arr_list);
          description.push(detail.description);
          type_status.push(detail.type);
        });

        HTTP.post(
          "/customer/order-create/" + this.$store.state.cartTakeOutTableId,
          {
            foodmenu_id: foodmenu_id,
            amount: amount,
            price: price,
            total_price: total_price,
            toping_id: toping_id,
            type_order: 1,
            topping_price: topping_price,
            description: description,
            type_status: type_status,
          },
          {
            headers: {
              Authorization: `Bearer ${this.$store.state.token}`,
            },
          }
        )
          .then((response) => {
            if (response.data.successful === true) {
              this.loading_page = false;
              this.is_submitting = false;
              this.alert_show_add = true;
            } else {
              // กรณี response.successful === false
              this.loading_page = false;
              this.is_submitting = false;
              const errorMsg = response.data.message || 'ไม่สามารถสั่งอาหารได้ กรุณาลองใหม่อีกครั้ง';
              this.error_message = errorMsg;
              this.alert_show_error = true;
            }
          })
          .catch((error) => {
            this.loading_page = false;
            this.is_submitting = false;
            
            if (error.response) {
              // HTTP Error (400, 401, 500, etc.)
              if (error.response.status === 401) {
                this.$store.commit("logOutSuccess");
                this.$router.push("/login");
                return;
              }
              
              // จัดการ error 400 (Validation Error)
              if (error.response.status === 400) {
                // ตรวจสอบว่ามี A La Carte ในตะกร้าหรือไม่ (type: 1)
                const hasALaCarte = this.$store.state.cartListTakeOutTable.some(item => item.type === 1)
                
                let errorMsg = (error.response.data && error.response.data.message) || 'เมนูที่เลือกไม่สามารถสั่งได้ใน ragne_buffets นี้ กรุณาเลือกเมนูอื่น'
                
                // ถ้ามี A La Carte ในตะกร้า แสดง error message ที่ชัดเจนขึ้น
                if (hasALaCarte) {
                  errorMsg = 'เมนูบุฟเฟ่ต์ที่เลือกไม่สามารถสั่งได้ใน ragne_buffets นี้ (เมนู A La Carte สามารถสั่งได้ทุก ragne_buffets) กรุณาเลือกเมนูบุฟเฟ่ต์ที่ถูกต้อง'
                }
                
                this.error_message = errorMsg;
                this.alert_show_error = true;
                
                // อาจต้อง refresh เมนูเพื่อให้แน่ใจว่าเป็นข้อมูลล่าสุด
                // this.refreshMenuList()
              } else if (error.response.status === 500) {
                // Server Error
                this.error_message = 'เกิดข้อผิดพลาดในระบบ กรุณาลองใหม่อีกครั้ง';
                this.alert_show_error = true;
              } else {
                // Error อื่นๆ
                const errorMsg = (error.response.data && error.response.data.message) || 'ไม่สามารถสั่งอาหารได้ กรุณาลองใหม่อีกครั้ง';
                this.error_message = errorMsg;
                this.alert_show_error = true;
              }
            } else {
              // Network error หรือ error อื่นๆ
              this.error_message = 'ไม่สามารถเชื่อมต่อกับเซิร์ฟเวอร์ได้ กรุณาตรวจสอบการเชื่อมต่ออินเทอร์เน็ต';
              this.alert_show_error = true;
            }
          });
      }
    },
    async confirmSuccess() {
      this.$store.commit("clearCartTakeOutTableListUser");
      this.$router.push("/takeoutusertable/" + this.$route.params.token);
    },
  },
  created() {
    HTTP.get(
      "/POS/table/check_token_opentable/" +
        this.$store.state.cartTakeOutTableId +
        "/" +
        this.$route.params.token,
      {
        headers: {
          Authorization: `Bearer ${this.$store.state.token}`,
        },
      }
    )
      .then((response) => {
        if (response.data.successful === false) {
          this.$store.commit("clearCartListUser");
          this.$store.commit("clearCartTakeOutTableListUser");
          this.$store.commit("clearCartListUserTakeOut");
          this.$store.commit("clearCartOrderOnlineUser");
          this.$router.push("/thankyouuser");
        }
      })
      .catch((error) => {
        if (error.response.status === 401) {
          this.$store.commit("logOutSuccess");
          this.$router.push("/login");
        }
        if (error.response.status === 500) {
          this.$store.commit("clearCartListUser");
          this.$store.commit("clearCartTakeOutTableListUser");
          this.$store.commit("clearCartListUserTakeOut");
          this.$store.commit("clearCartOrderOnlineUser");
          this.$router.push("/thankyouuser");
        }
      });
  },
  mounted() {
    this.colorRestaurant();
    this.tableDetail();
  },
};
</script>

<style scoped>
.color_header_cart_take_out_table {
  background: linear-gradient(to top, #038cc1, #55c0e9);
  position: fixed;
  width: 100%;
  z-index: 10;
}

.img_cart_header_cart_take_out_table {
  width: 50px;
}

.img_cart_header_cart_take_out_table > img {
  max-width: 100%;
}

.color_title_cart_take_out_table {
  color: #fff;
}

.link_back_cart_take_out_table {
  cursor: pointer;
}

.detail_cart_take_out_table {
  height: 100%;
  padding: 100px 12px 150px !important;
}

.confirm_cart_take_out_table {
  position: fixed;
  width: 100%;
  bottom: 0;
  background: #fff;
}

.titlefont_cart_take_out_table {
  font-size: 22px !important;
}

.topping_food_cart_take_out_table {
  font-size: 16px;
}

.result_cart_all_cart_take_out_table {
  width: 50px;
}

.result_cart_all_cart_take_out_table > img {
  max-width: 100%;
}

/* .amount_list_topping_cart_take_out_table{
     color: #ff5252;
} */

.note_cart_take_out_table {
  color: #ff5252;
}

.cart_detail_cart_take_out_table {
  display: grid;
  grid-template-columns: 80% 20%;
}

.delete_cart_detail_cart_take_out_table > div,
.delete_cart_detail_cart_take_out_table > div > button {
  height: 100%;
  width: 100%;
}
</style>
